import ModalRegisterPetition from "./ModalRegisterPetition";

export default ModalRegisterPetition;